import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// Axios instance for the NestJS backend. `withCredentials: true` carries the
// httpOnly auth cookies the backend issues. The 401 interceptor tries
// `/auth/refresh` once before letting the original error propagate — admin
// users stay signed in across long sessions without re-entering the magic
// link every 15 minutes.
export const apiClient = axios.create({
  baseURL,
  withCredentials: true,
});

let refreshing = null;

apiClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err?.config;
    if (!original || original._retryCount >= 1 || err?.response?.status !== 401) {
      return Promise.reject(err);
    }
    const url = original.url || '';
    if (url.startsWith('/auth/refresh') || url.startsWith('/auth/anonymous')) {
      return Promise.reject(err);
    }
    original._retryCount = (original._retryCount ?? 0) + 1;

    refreshing =
      refreshing ||
      apiClient.post('/auth/refresh').finally(() => {
        refreshing = null;
      });

    try {
      await refreshing;
    } catch {
      return Promise.reject(err);
    }

    return apiClient(original);
  },
);

export function getCurrentUserId() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)uid=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}
